"use client";

import { useAppDateTime } from "@/hooks/use-app-date-time";

export function RelativeTime({ date }: { date: Date | string }) {
  const { timeAgoCompact } = useAppDateTime({ live: true });
  return <span>{timeAgoCompact(date)}</span>;
}

export function UserAvatar({
  image,
  name,
  size = 40,
}: {
  image: string | null;
  name: string;
  size?: number;
}) {
  return (
    <div
      className="rounded-full bg-secondary overflow-hidden shrink-0"
      style={{ width: size, height: size }}
    >
      {image ? (
        <img src={image} alt={name} width={size} height={size} className="object-cover" />
      ) : (
        <div
          className="w-full h-full flex items-center justify-center font-bold text-muted-foreground"
          style={{ fontSize: size * 0.35 }}
        >
          {name.charAt(0).toUpperCase()}
        </div>
      )}
    </div>
  );
}
